<!--
 * @Author: weiwei.xue
 * @Date: 2020-05-22 11:16:54
 * @LastEditors: weiwei.xue
 * @LastEditTime: 2021-11-04 20:21:15
 * @Description: 
--> 

<template>
  <van-popup v-model="showProtocol" position="bottom" style="height:80%;" class="noSelect proPop" @close="closePop">
    <van-tabs v-model="active" :ellipsis="false" scrollspy sticky>
      <van-tab :title="tab.compactName" v-for="(tab,tabIndex) in tabList" :key="tabIndex">
        <div @scroll="handleScroll" v-html="tab.compactContent" class="proDetail" :id="tab.id"></div>
      </van-tab>
    </van-tabs>
    <van-button class="ensureBtn btn-backColor" v-if="!allRead" disabled>我已阅读并同意<span>({{leftTime}}s)</span></van-button>
    <van-button class="ensureBtn btn-backColor" v-else @click="ensurePro">我已阅读并同意</van-button>
  </van-popup>
</template>
<script>
import { Vue, Component } from "vue-property-decorator";
import { ProtocolPop } from "@/components";
import { getStore } from "@/utils/utils";
import * as api from "@/api/accountApplication";
const PRO_DETAIL_KEY = "proDetail";
@Component({
  name: "bankCard-message",
  components: {
    ProtocolPop,
  },
})
export default class BankRegistered extends Vue {
  showProtocol = true;
  leftTime = 8;
  checkValue = false;
  popShow = false;
  allRead = false;
  active = PRO_DETAIL_KEY + "0";
  show = false;
  tabList = [];
  readProtocol = {};
  checked = false;
  setIntervalBFlag = false; // 协议是否强制观看
  registAgreements = [
    {
      compactName: "《东航分期付产品服务协议》",
      compactType: "51",
    }
  ];
  protocols = [];
  created() {
    if (getStore("protocolCheck")) {
      console.log(getStore("protocolCheck"));
      this.checked = getStore("protocolCheck");
    }
    this.getProtocolDetail();
  }
  // 重新签订
  ensurePro() {
    this.$emit("ensurePro", true);
    // this.$emit("close");
  }
  // 获取协议详情
  getProtocolDetail() {
    console.log('jinlaile', JSON.parse(getStore('userInfo')))
    let queryArr = [];
    let registAgreements = [];
    let custName = getStore('userInfo') ? JSON.parse(getStore('userInfo')).custName : ''
    let certId = getStore('userInfo') ? JSON.parse(getStore('userInfo')).certId : ''
    queryArr = this.registAgreements.map((item) => {
      registAgreements.push({ compactName: item.compactName });
      return api.applicationProtol({ compactType: item.compactType, userName: custName, certId: certId });
    });
    Promise.all(queryArr).then((values) => {
      values.forEach(({ code, data: { compactContent } }, index) => {
        if (code == 200) {
          registAgreements[index].compactContent = compactContent;
        }
      });
      this.protocols = registAgreements;
      if (this.allRead) this.allRead = true;
      if (this.show) this.show2 = true;
      this.initTabs();
      this.initTime();
    });
  }
  initTime() {
    setTimeout(() => {
      this.leftTime = this.leftTime - 1;
      if (this.leftTime > 0) {
        this.initTime();
      } else {
        this.allRead = true;
      }
    }, 1000);
  }
  closePop() {
    this.$emit("close");
    // this.popShow = false;
  }
  handleCheck(val) {
    this.checkValue = val;
    this.$emit("onchecked", val);
  }
  handleScroll(e) {
    let target = e.target;
    let { clientHeight, scrollTop, scrollHeight } = target;
    if (scrollHeight - clientHeight - scrollTop < 1) {
      this.readProtocol[target.id] = true;
      // 拉至底部，跳转到下一未读协议
      let nextTab = this.getNextTab();
      if (nextTab || nextTab === 0) this.active = nextTab;
    }
  }
  getNextTab() {
    let readProtocol = this.readProtocol;
    let nextKey = -1;
    for (let k in readProtocol) {
      if (!readProtocol[k]) {
        nextKey = parseInt(k.replace(PRO_DETAIL_KEY, ""));
        break;
      }
    }
    if (nextKey == -1) {
      // 协议已经全部阅读完
      // this.allRead = true;
      return false;
    } else {
      // 下一个协议
      return nextKey;
    }
  }
  initTabs() {
    let tabList = [];
    let readProtocol = {};

    this.protocols.forEach((item, i) => {
      tabList.push({
        ...item,
        compactName: item.compactName.replace(/[《》]/g, ""),
        id: PRO_DETAIL_KEY + i,
      });
    });

    tabList.forEach((item, index) => {
      readProtocol[PRO_DETAIL_KEY + index] = false;
    });
    this.readProtocol = readProtocol;
    this.tabList = tabList;
  }

}
</script>
<style scoped lang="less">
.proDetail {
  height: 100%;
  overflow: auto;
  padding: 16px 16px 0;
}
</style>